import React from 'react';
import { Card, Avatar, Flex } from 'antd';
import { UserOutlined, PhoneOutlined } from '@ant-design/icons';
import StarRating from './StarRating';
import { censorPhoneNumber } from '../../utils/phoneUtils';
import { ReviewCardProps } from '../../@types/review';

const ReviewCard: React.FC<ReviewCardProps> = ({ review, className }) => {
    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('th-TH', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        }).format(date);
    };

    return (
        <Card
            className={`review-card ${className || ''}`}
            bodyStyle={{ padding: '20px' }}
        >
            <div className="card-content">
                {/* Header - Customer Info */}
                <Flex justify="space-between" wrap="wrap" gap="small">
                    <div className="customer-info">
                        <Avatar
                            size={40}
                            icon={<UserOutlined />}
                            className="customer-avatar"
                        />
                        <div className="customer-details">
                            <div className="phone-container">
                                <PhoneOutlined className="phone-icon" />
                                <span className="phone-number">
                                    {censorPhoneNumber(review.phoneNumber)}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="rating-container">
                        <StarRating rating={review.rating} size="small" />
                    </div>
                </Flex>

                {/* Review Content */}
                <div className="review-content">
                    <p className="review-text">
                        "{review.reviewText}"
                    </p>
                </div>

                {/* Footer - Date */}
                <div className="card-footer">
                    <p className="review-date">
                        {formatDate(review.reviewDate)}
                    </p>
                </div>
            </div>
        </Card>
    );
};

export default ReviewCard; 